import { useQuery } from "@tanstack/react-query";
import { useFilesForCompanyId } from "./useFiles";
import { useParams } from "react-router-dom";
import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { ThemeProps } from "@rjsf/core";
import axios from "axios";
import { SasFileResult } from "src/types/InspectionUpdateRequest";

export function useFormSchema() {
  const { schemaId } = useParams();
  const { data: files } = useFilesForCompanyId();
  const schemaQuery = useQuery({
    queryKey: ["schema", schemaId],
    queryFn: async () => {
      const file = files?.find((file) => file.id?.toString() === schemaId);
      if (file) {
        const response = await axios.get(file.webUrl || file.files[0]!);
        const data = response.data;
        data.file = file;
        return data as {
          schema: RJSFSchema;
          uiSchema: UiSchema;
          file: SasFileResult;
          theme: {
            colors: {
              primary: string;
              secondary: string;
              text: string;
              error: string;
              warning: string;
              success: string;
              info: string;
              backgroundColor: string;
              headerTextColor: string;
              headerBackgroundColor: string;
            };
            fonts: {
              header: {
                family: string;
                size: string;
              };
              text: {
                family: string;
                size: string;
              };
            };
          };
        };
      } else {
        return null;
      }
    },
    enabled: !!schemaId,
  });
  return schemaQuery;
}
